import { useSelector } from 'react-redux';

import EnumSelect from 'components/field/EnumSelect';
import FormItem from 'components/form/FormItem';

const ConfigurationOptionEnumList = ({ configOptions, fieldName, formMethods, isLoading, propJSON }) => {
	const { setValue } = formMethods;

	const { planName } = useSelector((state) => state.user);

	return (
		<>
			{configOptions
				.filter((x) => x.type === 'enum')
				.filter((x) => (x?.planName ? x.planName === planName : true))
				.map((item, index) => (
					<FormItem key={index} label={item.name} toolTip={item.toolTip ?? null} isLoading={isLoading}>
						<EnumSelect
							name={`${fieldName}.${item.name}`}
							data={item.data}
							value={propJSON[item.name]}
							setValue={(value) => {
								setValue(`${fieldName}.${item.name}`, value, {
									shouldValidate: true,
									shouldDirty: true
								});
							}}
							searchable={false}
							valueRemovable={false}
						/>
					</FormItem>
				))}
		</>
	);
};

export default ConfigurationOptionEnumList;
